import {createAsyncThunk, createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {
    getAiReportSettingsApi,
    generateAiReportApi,
    getAiReportHistoryApi,
    getAiReportByIdApi,
    deleteAiReportApi,
    chatAiReportApi,
    confirmAiReportApi,
} from "../../../../services/report";

export const getAiReportSettings = createAsyncThunk('report/ai-reports/settings', async (data, {dispatch}) => {
    const response = await getAiReportSettingsApi();
    return response.response;
});

export const chatAiReport = createAsyncThunk('report/ai-reports/chat', async (data, {dispatch}) => {
    const response = await chatAiReportApi(data);
    return response.response;
});

export const confirmAiReport = createAsyncThunk('report/ai-reports/confirm', async (data, {dispatch}) => {
    const response = await confirmAiReportApi(data);
    return response.response;
});

export const generateAiReport = createAsyncThunk('report/ai-reports/generate', async (data, {dispatch}) => {
    const response = await generateAiReportApi(data);
    return response.response;
});

export const getAiReportHistory = createAsyncThunk('report/ai-reports/history', async (data, {dispatch}) => {
    const response = await getAiReportHistoryApi(data);
    dispatch(setTableRowCount(response.response.count));
    return response.response.data;
});

export const getAiReportById = createAsyncThunk('report/ai-reports/show', async (id, {dispatch}) => {
    const response = await getAiReportByIdApi(id);
    return response.response;
});

export const deleteAiReport = createAsyncThunk('report/ai-reports/delete', async (id, {dispatch}) => {
    const response = await deleteAiReportApi(id);
    return id;
});

const aiReportAdapter = createEntityAdapter({});

export const {selectAll: selectAiReports, selectById: selectAiReportById} = aiReportAdapter.getSelectors(
    state => state.report.aiReport
);

const aiReportSlice = createSlice({
    name: 'aiReport',
    initialState: aiReportAdapter.getInitialState({
        tableRowCount: 0,
        settings: {
            sellers: [],
            partners: [],
        },
        currentReport: null,
        generating: false,
        conversationId: null,
        chatLoading: false,
        isReady: false,
        reportIntent: null,
    }),
    reducers: {
        setTableRowCount: (state, action) => {
            state.tableRowCount = action.payload;
        },
        setCurrentReport: (state, action) => {
            state.currentReport = action.payload;
        },
        setGenerating: (state, action) => {
            state.generating = action.payload;
        },
        resetConversation: (state) => {
            state.conversationId = null;
            state.chatLoading = false;
            state.isReady = false;
            state.reportIntent = null;
        },
    },
    extraReducers: {
        [getAiReportSettings.fulfilled]: (state, action) => {
            state.settings = action.payload;
        },
        [getAiReportHistory.fulfilled]: aiReportAdapter.setAll,
        [chatAiReport.pending]: (state) => {
            state.chatLoading = true;
        },
        [chatAiReport.fulfilled]: (state, action) => {
            state.chatLoading = false;
            if (action.payload.conversation_id) {
                state.conversationId = action.payload.conversation_id;
            }
            state.isReady = action.payload.is_ready || false;
            state.reportIntent = action.payload.report_intent || null;
        },
        [chatAiReport.rejected]: (state) => {
            state.chatLoading = false;
        },
        [confirmAiReport.fulfilled]: (state, action) => {
            state.generating = true;
            state.currentReport = action.payload;
        },
        [generateAiReport.fulfilled]: (state, action) => {
            state.generating = true;
            state.currentReport = action.payload;
        },
        [getAiReportById.fulfilled]: (state, action) => {
            state.currentReport = action.payload;
            if (action.payload.status === 'completed' || action.payload.status === 'failed') {
                state.generating = false;
            }
        },
        [deleteAiReport.fulfilled]: (state, action) => {
            aiReportAdapter.removeOne(state, action.payload);
            state.tableRowCount = state.tableRowCount - 1;
        },
    }
});

export const {setTableRowCount, setCurrentReport, setGenerating, resetConversation} = aiReportSlice.actions;
export default aiReportSlice.reducer;
